import { UserInspectionType } from './types';

import { UserInspectionActionType } from 'enums';
import { UserInspectionActionReturnType } from 'state/actions';

const initState: UserInspectionType = {
  inspectionId: '',
};

export const userInspectionReducer = (
  // eslint-disable-next-line default-param-last
  state: UserInspectionType = initState,
  action: UserInspectionActionReturnType,
): UserInspectionType => {
  switch (action.type) {
    case UserInspectionActionType.SET_USER_INSPECTION:
      return { ...state, ...action.userInspection };
    case UserInspectionActionType.UPDATE_USER_INSPECTION:
      return {
        ...state,
        ...action.userInspection,
      };
    default:
      return state;
  }
};
